import { Observable } from 'rxjs';
import { fetchProjectImageAnnotationListAPI } from '../../api/fetch-functions/project-image-annotation';
import { IAnnotationType } from '../../types/record/annotation';
import { ListWithPromiseState } from './common/list-with-status';
import {
  fetchIdsStreamGenerator,
  fetchListFnGenerator,
  listOfIdFnGenerator,
  twoIdListSetReducerGenerator,
  twoIdListSetStreamGenerator,
  updateStreamGenerator
} from './common/two-id-list';

const fetchSignal$ = fetchIdsStreamGenerator();

// 仮引数のリネームのためいったん変数`f`に格納
const f = fetchListFnGenerator(fetchSignal$);
export const fetchProjectImageAnnotationListOf = (
  projectId: number,
  imageId: number
) => {
  f(projectId, imageId);
};

/**
 * @description
 * `fetchProjectImageAnnotationListOf(projectId, imageId)` を実行すると
 * `projectImageAnnotationListSet$` の該当idの要素を re-fetch する．
 */
const updateProjectImageAnnotationList$ = updateStreamGenerator(
  fetchSignal$,
  fetchProjectImageAnnotationListAPI
);

const projectImageAnnotationListSetReducer = twoIdListSetReducerGenerator<
  IAnnotationType
>();

/**
 * @description
 * すべての projectImageList の集合．必要になったものからfetchして蓄える．
 * 複数のcomponentで共有するため．
 */
const projectImageAnnotationListSet$ = twoIdListSetStreamGenerator(
  updateProjectImageAnnotationList$,
  projectImageAnnotationListSetReducer
);

const g = listOfIdFnGenerator<IAnnotationType>(projectImageAnnotationListSet$);
export const projectImageAnnotationListOf = (
  projectId: number,
  imageId: number
): Observable<ListWithPromiseState<IAnnotationType>> => {
  fetchProjectImageAnnotationListOf(projectId, imageId);
  return g(projectId, imageId);
};
